import { render, staticRenderFns } from "./ListCategories.vue?vue&type=template&id=654dd378&scoped=true&"
import script from "./ListCategories.vue?vue&type=script&lang=ts&"
export * from "./ListCategories.vue?vue&type=script&lang=ts&"
import style0 from "./ListCategories.vue?vue&type=style&index=0&id=654dd378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654dd378",
  null
  
)

export default component.exports